import React, { useState, useEffect } from 'react';
import { Search, Moon, Sun as SunIcon, Clock } from 'lucide-react'; 

const paraData = [
  { number: 1, englishName: "Alif Lam Meem", name: "آلٓمٓ", type: 'juz', englishNameTranslation: "Para 1", numberOfAyahs: 148 },
  { number: 2, englishName: "Sayaqool", name: "سَيَقُولُ", type: 'juz', englishNameTranslation: "Para 2", numberOfAyahs: 111 },
  { number: 3, englishName: "Tilkal Rusul", name: "تِلْكَ ٱلرُّسُلُ", type: 'juz', englishNameTranslation: "Para 3", numberOfAyahs: 126 },
  { number: 4, englishName: "Lan Tanaloo", name: "لَنْ تَنَالُوا", type: 'juz', englishNameTranslation: "Para 4", numberOfAyahs: 131 },
  { number: 5, englishName: "Wal Mohsanat", name: "وَٱلْمُحْصَنَاتُ", type: 'juz', englishNameTranslation: "Para 5", numberOfAyahs: 124 },
  { number: 6, englishName: "La Yuhibbullah", name: "لَا يُحِبُّ ٱللَّهُ", type: 'juz', englishNameTranslation: "Para 6", numberOfAyahs: 110 },
  { number: 7, englishName: "Wa Iza Samiu", name: "وَإِذَا سَمِعُوا", type: 'juz', englishNameTranslation: "Para 7", numberOfAyahs: 149 },
  { number: 8, englishName: "Wa Lau Annana", name: "وَلَوْ أَنَّنَا", type: 'juz', englishNameTranslation: "Para 8", numberOfAyahs: 142 },
  { number: 9, englishName: "Qalal Malao", name: "قَالَ ٱلْمَلَأُ", type: 'juz', englishNameTranslation: "Para 9", numberOfAyahs: 159 },
  { number: 10, englishName: "Wa A'lamu", name: "وَٱعْلَمُوا", type: 'juz', englishNameTranslation: "Para 10", numberOfAyahs: 127 },
  { number: 11, englishName: "Yatazeroon", name: "يَعْتَذِرُونَ", type: 'juz', englishNameTranslation: "Para 11", numberOfAyahs: 151 },
  { number: 12, englishName: "Wa Mamin Da'abat", name: "وَمَا مِنْ دَابَّةٍ", type: 'juz', englishNameTranslation: "Para 12", numberOfAyahs: 170 },
  { number: 13, englishName: "Wa Ma Ubarri'oo", name: "وَمَا أُبَرِّئُ", type: 'juz', englishNameTranslation: "Para 13", numberOfAyahs: 154 },
  { number: 14, englishName: "Rubama", name: "رُبَمَا", type: 'juz', englishNameTranslation: "Para 14", numberOfAyahs: 227 },
  { number: 15, englishName: "Subhanallazi", name: "سُبْحَانَ ٱلَّذِى", type: 'juz', englishNameTranslation: "Para 15", numberOfAyahs: 185 },
  { number: 16, englishName: "Qal Alam", name: "قَالَ أَلَمْ", type: 'juz', englishNameTranslation: "Para 16", numberOfAyahs: 269 },
  { number: 17, englishName: "Iqtaraba", name: "ٱقْتَرَبَ", type: 'juz', englishNameTranslation: "Para 17", numberOfAyahs: 190 },
  { number: 18, englishName: "Qadd Aflaha", name: "قَدْ أَفْلَحَ", type: 'juz', englishNameTranslation: "Para 18", numberOfAyahs: 202 },
  { number: 19, englishName: "Wa Qalallazina", name: "وَقَالَ ٱلَّذِينَ", type: 'juz', englishNameTranslation: "Para 19", numberOfAyahs: 339 },
  { number: 20, englishName: "A'man Khalaqa", name: "أَمَّنْ خَلَقَ", type: 'juz', englishNameTranslation: "Para 20", numberOfAyahs: 171 },
  { number: 21, englishName: "Utlu Ma Oohi", name: "ٱتْلُ مَا أُوحِىَ", type: 'juz', englishNameTranslation: "Para 21", numberOfAyahs: 178 },
  { number: 22, englishName: "Wa Manyaqnut", name: "وَمَنْ يَقْنُتْ", type: 'juz', englishNameTranslation: "Para 22", numberOfAyahs: 169 },
  { number: 23, englishName: "Wa Mali", name: "وَمَا لِىَ", type: 'juz', englishNameTranslation: "Para 23", numberOfAyahs: 357 },
  { number: 24, englishName: "Faman Azlam", name: "فَمَنْ أَظْلَمُ", type: 'juz', englishNameTranslation: "Para 24", numberOfAyahs: 175 },
  { number: 25, englishName: "Elahe Yuraddo", name: "إِلَيْهِ يُرَدُّ", type: 'juz', englishNameTranslation: "Para 25", numberOfAyahs: 246 },
  { number: 26, englishName: "Ha'a Meem", name: "حمٓ", type: 'juz', englishNameTranslation: "Para 26", numberOfAyahs: 195 },
  { number: 27, englishName: "Qala Fama Khatbukum", name: "قَالَ فَمَا خَطْبُكُمْ", type: 'juz', englishNameTranslation: "Para 27", numberOfAyahs: 399 },
  { number: 28, englishName: "Qadd Sami Allah", name: "قَدْ سَمِعَ ٱللَّهُ", type: 'juz', englishNameTranslation: "Para 28", numberOfAyahs: 137 },
  { number: 29, englishName: "Tabarakallazi", name: "تَبَارَكَ ٱلَّذِى", type: 'juz', englishNameTranslation: "Para 29", numberOfAyahs: 431 },
  { number: 30, englishName: "Amma Yatasa'aloon", name: "عَمَّ يَتَسَاءَلُونَ", type: 'juz', englishNameTranslation: "Para 30", numberOfAyahs: 564 }
];

const SurahList = ({ onSurahSelect, theme, toggleTheme }) => {
  const [surahs, setSurahs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeView, setActiveView] = useState('surah'); 
  
  const isDarkMode = theme === 'dark';
  const [recentSurahs, setRecentSurahs] = useState([]);

  useEffect(() => {
    const fetchSurahs = async () => {
      try {
        const response = await fetch('https://api.alquran.cloud/v1/surah');
        const data = await response.json();
        setSurahs(data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching surahs:", error);
        setLoading(false);
      }
    };
    fetchSurahs();

    const loadRecents = () => {
        try {
            const saved = localStorage.getItem('quranRecents');
            if(saved) {
                setRecentSurahs(JSON.parse(saved));
            }
        } catch(e) { console.error(e); }
    };
    loadRecents();
  }, []);

  const handleSurahClick = (surah) => {
      try {
          const saved = localStorage.getItem('quranRecents');
          let currentRecents = saved ? JSON.parse(saved) : [];

          currentRecents = currentRecents.filter(item => !(item.number === surah.number && item.type === surah.type));

          currentRecents.unshift({
              number: surah.number,
              name: surah.name,
              englishName: surah.englishName,
              revelationType: surah.revelationType || 'JUZ',
              numberOfAyahs: surah.numberOfAyahs,
              type: surah.type || 'surah'
          });

          if (currentRecents.length > 10) {
              currentRecents = currentRecents.slice(0, 10);
          }

          localStorage.setItem('quranRecents', JSON.stringify(currentRecents));
          setRecentSurahs(currentRecents);

      } catch (e) {
          console.error("Error saving recent:", e);
      }

      onSurahSelect(surah);
  };

  const filteredSurahs = surahs.filter(s => 
    s.englishName.toLowerCase().includes(searchQuery.toLowerCase()) || 
    s.name.includes(searchQuery) ||
    String(s.number).includes(searchQuery)
  );
  
  const filteredParas = paraData.filter(p => 
    p.englishName.toLowerCase().includes(searchQuery.toLowerCase()) || 
    p.name.includes(searchQuery) ||
    String(p.number).includes(searchQuery)
  );

  if (loading) return (
    <div className={`loading-screen ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
        <div className="premium-loader"></div>
    </div>
  );

  return (
    <div className={`list-container ${isDarkMode ? 'dark-mode' : 'light-mode'}`} style={{paddingBottom: '60px'}}>
      
      <style>{`
        .surah-grid-premium {
          display: flex !important;
          flex-direction: column !important;
          gap: 0 !important;
          padding: 0 10px !important;
        }
        
        .surah-card-premium {
          margin: 0 !important;
          border-radius: 0 !important;
          border-bottom: 1px solid var(--glass-border) !important;
          padding: 12px 10px !important;
          background: transparent !important;
          box-shadow: none !important;
          display: flex !important;
          align-items: center !important;
          transition: background 0.2s !important;
        }
        
        .surah-card-premium:hover, .surah-card-premium:active {
          background: rgba(212, 175, 55, 0.05) !important;
        }
        
        .card-number-box { min-width: 32px !important; height: 32px !important; display: flex; align-items: center; justify-content: center; }
        .octagram-shape { width: 28px !important; height: 28px !important; }
        .octagram-shape span { font-size: 0.7rem !important; }
        
        .card-top-row { display: flex !important; flex-direction: column !important; align-items: flex-start !important; margin: 0 !important; border: none !important; padding: 0 !important; }
        
        .surah-name-en { font-size: 0.85rem !important; margin: 0 !important; font-weight: 600 !important;}
        .surah-meaning-en { font-size: 0.65rem !important; margin: 0 !important; }
        
        /* ✅ PREMIUM GAP LINE: Ye line khali jagah ko khoobsurti se bhar de gi */
        .premium-gap-line {
           flex: 1; /* Pura bacha hua gap le legi */
           border-bottom: 2px dotted var(--gold-dim);
           opacity: 0.35;
           margin: 0 15px;
           transform: translateY(8px);
        }

        /* ✅ ARABIC TEXT THODA LEFT KI TARAF: margin-right use kiya hai */
        .card-right-side { 
          display: flex; 
          flex-direction: column; 
          align-items: flex-end; 
          flex-shrink: 0; 
          text-align: right;
          margin-right: 8%; /* Iski wajah se Arabic text right edge se thoda left (andar) aayega */
        }
        
        .surah-name-ar-compact { 
          font-family: 'Noto Nastaliq Urdu', serif; 
          font-size: 1.3rem !important; 
          color: var(--gold-shiny); 
          line-height: 1.4; 
        }
        
        .compact-badges { display: flex; gap: 6px; font-size: 0.65rem; color: var(--text-secondary); margin-top: 4px; }
        .compact-badge { background: rgba(255,255,255,0.05); padding: 2px 6px; border-radius: 4px; }
        
        .card-bottom-row { display: none !important; }
        
        .hero-section-premium { padding: 15px 15px 25px 15px !important; }
        .hero-title-premium { font-size: 1.1rem !important; margin-bottom: 8px !important; }
        .hero-subtitle-pill { font-size: 0.6rem !important; padding: 3px 10px !important; }
        .search-input-premium { font-size: 0.8rem !important; padding: 6px 12px 6px 30px !important; }
        .search-icon-premium { width: 14px !important; left: 10px !important; }
        
        .view-toggle-premium { margin: -15px 20px 10px 20px !important; padding: 4px !important; border-radius: 20px !important; }
        .toggle-btn { font-size: 0.75rem !important; padding: 6px !important; border-radius: 15px !important; }
        
        .recent-section-wrapper { padding: 0 10px 10px 10px !important; }
        .recent-title { font-size: 0.7rem !important; margin-bottom: 6px !important; }
        .recent-card { padding: 6px 12px !important; min-width: 80px !important; gap: 4px !important; border-radius: 10px !important; }
        .recent-arabic-name { font-size: 0.9rem !important; }
        .recent-number-badge { font-size: 0.55rem !important; padding: 2px 6px !important; }
      `}</style>

      {/* --- HERO SECTION --- */}
      <div className="hero-section-premium">
        <div className="hero-vignette"></div>
        <div className="hero-content-wrapper">
           <div className="theme-toggle-corner" onClick={toggleTheme} aria-label="Toggle Theme">
              {isDarkMode ? <SunIcon size={16} /> : <Moon size={16} />}
           </div>

           <div className="hero-titles-group">
               <div className="sun-icon-wrapper" style={{ display: 'none' }}></div>
               <h1 className="hero-title-premium">AL-QURAN AL-KAREEM</h1>
               <div className="hero-subtitle-pill">READING MODE</div>
           </div>
           
           <div className="search-container-premium">
              <div className="search-input-wrapper">
                  <Search className="search-icon-premium" />
                  <input 
                    type="text" 
                    placeholder={activeView === 'surah' ? "Search Surah..." : "Search Para..."}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="search-input-premium"
                  />
              </div>
           </div>
        </div>
      </div>

      {/* --- SURAH / PARA TOGGLE --- */}
      <div className="view-toggle-premium">
         <button className={`toggle-btn ${activeView === 'surah' ? 'active' : ''}`} onClick={() => setActiveView('surah')}>
            سورتیں
         </button>
         <button className={`toggle-btn ${activeView === 'para' ? 'active' : ''}`} onClick={() => setActiveView('para')}>
            پارے (Juz)
         </button>
      </div>

      {/* --- RECENTLY VIEWED SURAHS/PARAS --- */}
      {recentSurahs.length > 0 && !searchQuery && (
          <div className="recent-section-wrapper">
              <div className="recent-title">
                  <Clock size={12} />
                  <span>Recently Read</span>
              </div>
              <div className="recent-horizontal-scroll">
                  {recentSurahs.map((recent, idx) => {
                      const arabicName = recent.type === 'juz' 
                          ? paraData.find(p => p.number === recent.number)?.name || recent.name
                          : surahs.find(s => s.number === recent.number)?.name || recent.name;

                      return (
                          <div key={`${recent.type}-${recent.number}-${idx}`} className="recent-card" onClick={() => handleSurahClick(recent)}>
                              <span className="recent-number-badge">
                                  {recent.number}
                              </span>
                              <span className="recent-arabic-name">{arabicName}</span>
                              <span style={{fontSize: '0.6rem', color: 'var(--text-muted)', fontWeight: 'bold', fontFamily: "'Poppins', sans-serif"}}>
                                  {recent.type === 'juz' ? `Para ${recent.number}` : `Surah ${recent.number}`}
                              </span>
                          </div>
                      );
                  })}
              </div>
          </div>
      )}

      {/* --- SURAH / PARA GAPLESS GRID --- */}
      <div className="surah-grid-premium">
        {activeView === 'surah' ? (
          filteredSurahs.map((surah) => (
            <div key={`surah-${surah.number}`} className="surah-card-premium" onClick={() => handleSurahClick(surah)}>
              
              {/* Left side */}
              <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                  <div className="card-number-box">
                     <div className="octagram-shape">
                        <span>{surah.number}</span>
                     </div>
                  </div>
                  <div className="card-top-row">
                     <h3 className="surah-name-en">{surah.englishName}</h3>
                     <p className="surah-meaning-en">{surah.englishNameTranslation}</p>
                  </div>
              </div>

              {/* ✅ Premium Dotted Leader Line (Gap ko khoobsurti se cover karta hai) */}
              <div className="premium-gap-line"></div>

              {/* Right Side (Arabic Text) shifted slightly left */}
              <div className="card-right-side">
                 <span className="surah-name-ar-compact">{surah.name}</span>
                 <div className="compact-badges">
                    <span className="compact-badge">{surah.revelationType === 'Meccan' ? 'مکی' : surah.revelationType === 'Medinan' ? 'مدنی' : surah.revelationType}</span>
                    <span className="compact-badge">{surah.numberOfAyahs} آیات</span>
                 </div>
              </div>
              
            </div>
          ))
        ) : (
          filteredParas.map((para) => (
            <div key={`para-${para.number}`} className="surah-card-premium" onClick={() => handleSurahClick(para)}>
              
              {/* Left side */}
              <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                  <div className="card-number-box">
                     <div className="octagram-shape">
                        <span>{para.number}</span>
                     </div>
                  </div>
                  <div className="card-top-row">
                     <h3 className="surah-name-en">{para.englishName}</h3>
                     <p className="surah-meaning-en">{para.englishNameTranslation}</p>
                  </div>
              </div>

              {/* ✅ Premium Dotted Leader Line */}
              <div className="premium-gap-line"></div>

              {/* Right Side (Arabic Text) shifted slightly left */}
              <div className="card-right-side">
                 <span className="surah-name-ar-compact">{para.name}</span>
                 <div className="compact-badges">
                    <span className="compact-badge">پارہ</span>
                    <span className="compact-badge">{para.numberOfAyahs} آیات</span>
                 </div>
              </div>

            </div>
          ))
        )}
      </div>
      
    </div>
  );
};

export default SurahList;